import React, { useEffect } from "react";

export const RedirectNewError404 = () => {
  useEffect(() => {
    window.location.replace("https://homie.mx/new/404");
  }, []);

  return <></>;
};
